import React, { FC } from 'react';
import { parse, stringify } from 'query-string';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';

import { Outlet } from 'react-router-dom';
import { QueryParamProvider } from 'use-query-params';
import { AppLoader } from '@jaam/web-core';

const PublicRoutes: FC = () => {
  return (

      <QueryParamProvider
        options={{
          searchStringToObject: parse,
          objectToSearchString: stringify,
        }}
        adapter={ReactRouter6Adapter}
      >
        <React.Suspense
          fallback={
            <div className="flex gap-4 mt-20 max-w-[1440px] mx-auto">
              <AppLoader />
            </div>
          }
        >
          <Outlet />
        </React.Suspense>
      </QueryParamProvider>

  );
};

export default PublicRoutes;
